import React from 'react';
import {
  SalesforceDealField,
  SalesforceDeal,
  useUpdateSalesforceDealFieldCheckboxValueMutation,
} from 'api';

interface Props {
  salesforceDeal: SalesforceDeal;
  field: SalesforceDealField;
}

const CheckboxFieldValue = ({salesforceDeal, field}: Props) => {
  const value = salesforceDeal.addition[`${field.fieldName}`];
  const [errorMessage, setErrorMessage] = React.useState('');
  const [updateFieldValue] = useUpdateSalesforceDealFieldCheckboxValueMutation({
    onCompleted: (data) => {
      setErrorMessage(data.updateSalesforceDealFieldCheckboxValue.error);
    },
  });

  return (
    <>
      <input
        className="cursor-pointer"
        type="checkbox"
        name={field.label}
        checked={value}
        disabled={!field.fieldName.endsWith('__c')}
        onChange={(e) =>
          updateFieldValue({
            variables: {
              salesforceDealId: salesforceDeal.id,
              attributes: {
                fieldName: field.fieldName,
                value: e.target.checked,
              },
            },
          })
        }
      />
      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    </>
  );
};

export default CheckboxFieldValue;
